import { Link } from 'react-router-dom';
import { hero_img } from '../../imports';
import './Hero.css';

const Hero = () => {
    return (
        <div className="hero-container">
            <div className="hero-content">
                <h1 className="hero-title">Premium Detailing in North Dakota</h1>
                <p className="hero-description">Don't deny yourself the pleasure of driving the cleanest vehicle in town.</p>
                <Link to='/booking'>
                    <button className="hero-button">Book now</button>
                </Link>
            </div>
            <div className='hero-overlay'></div>
            <div className="hero-image-container">
                <img src={hero_img} alt="hero" className='hero-image' />
            </div>
        </div>
    )
}

export default Hero;
